import { render } from "./DbsHeader.vue?vue&type=template&id=c4298ba6&scoped=true"
import script from "./DbsHeader.vue?vue&type=script&lang=js"
export * from "./DbsHeader.vue?vue&type=script&lang=js"

import "./DbsHeader.vue?vue&type=style&index=0&id=c4298ba6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c4298ba6"

export default script